'use client'

import React from "react";
import {cn} from "@/lib/utils";
import Image from "next/image";
import {GROQImage} from "@/sanity/lib/types";

export default function Chip({
  image,
  imageBG,
  text,
  textBG,
  className = "",
}: {
  image?: GROQImage;
  imageBG?: string;
  text: string;
  textBG?: string;
  className?: string;
}){
  if (!text) return null;

  return (
    <div className={cn(
      "inline-flex min-h-[4rem] prose-p:text-[#052920] mb-[2rem]",
      className
    )}>
      {image && (
        <div className={cn(
          "w-[4rem] flex items-center justify-center",
          imageBG ? imageBG : 'bg-[#D9F9B9]'
        )}>
          <Image
            className="!w-[2rem]"
            src={image}
            alt=""
          />
        </div>
      )}
      <div className={cn(
        "flex items-center px-[1rem]",
        textBG ? textBG : 'bg-white'
      )}>
        <p className="mb-0 leading-none text-[2rem]">{text}</p>
      </div>
    </div>
  );
}